@use '@lib/assets/styles/main.scss' as *;
@use './input-vars' as *;
@use './input-extends' as *;
@use './Default.module' as *;

.input {
  @include inputStyle;

  &.inputLarge {
    @include input;
    height: $inputLargeHeight;
  }

  &.inputMedium {
    @include input;
    height: $inputMediumHeight;
  }

  &.inputWithLeftIcon {
    padding-left: $inputSidePaddingWithOneIcon;
  }

  &.inputWithRightIcon {
    padding-right: $inputSidePaddingWithOneIcon;
  }

  &.inputClearable {
    padding-right: $inputSidePaddingWithOneIcon;

    &.inputWithRightIcon {
      padding-right: $inputSidePaddingWithTwoIcon;
    }
  }

  &.textareaLarge {
    @include textarea;
    resize: none;
    height: $textareaLargeHeight;
  }

  &.textareaMedium {
    @include textarea;
    resize: none;
    height: $textareaMediumHeight;
  }

  &.textareaMediumWithResize {
    @include input;
    @include scrollStyles;
    resize: vertical;
    min-height: $inputMediumHeight;
    max-height: 5 * $inputMediumHeight;
  }

  &.textareaLargeWithResize {
    @include input;
    @include scrollStyles;
    resize: vertical;
    min-height: $inputLargeHeight;
    max-height: 5 * $inputLargeHeight;
  }

  &:disabled {
    text-overflow: ellipsis;
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.fieldLabel {
  z-index: 1;
  cursor: pointer;
  position: absolute;
  transform: translateY(-50%);
  left: $inputDefaultHorizontalPadding;
  max-width: Calc(100% - $inputDefaultHorizontalPadding * 2);
  display: block;
  font-size: 15px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.1px;
  background: $gray0;
  transition: top 0.2s ease, left 0.3s ease;

  [class*="react-tel-input"] + & {
    left: $inputTelLeftHorizontalPadding;
    max-width: Calc(100% - $inputSidePaddingWithOneIcon * 2);
  }

  &.fieldLabelWhenText {
    top: 50%;
  }

  &.fieldLabelWhenDisabled {
    color: $disable500;
    cursor: not-allowed;
  }

  &.fieldLabelWhenTextarea {
    top: $textareaIconVerticalIndent;
  }

  &.fieldLabelWhenLeftIcon {
    left: $inputSidePaddingWithOneIcon;
    max-width: Calc(100% - $inputSidePaddingWithOneIcon * 2);
  }

  .inputWrapper:focus-within &,
  [class*='focused'] &,
  &.fieldLabelWhenValue,
  .inputWrapperWhenValue &,
  .input:focus + &,
  .input[type="number"]:not(:placeholder-shown) + &,
  .input:-webkit-autofill + & {
    top: 0;
    left: 12px;
    padding: 0 4px;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    max-width: Calc(100% - 12px - 12px);
  }

  .inputWrapper:focus-within &,
  .input:focus + & {
    color: $blue500;
  }

  .inputWrapperWhenError &,
  &.fieldLabelWhenError,
  .input.inputWithError + & {
    color: $error900 !important;
  }
}

.leftIconWrap,
.rightIconWrap,
.disabledIconWrap,
.clearIconWrap {
  @include iconWrap;

  .inputWrapperWithTextarea & {
    top: $textareaIconVerticalIndent;
  }
}

.leftIconWrap {
  @include leftRightIcon;
  left: $inputIconHorizontalSideIndent;

  .inputWrapperWithDisabled & {
    @include disabledIcon;
  }
}

.rightIconWrap {
  @include leftRightIcon;
  right: $inputIconHorizontalSideIndent;

  .inputWrapperWithDisabled & {
    @include disabledIcon;
  }

  .inputWrapperWithNumber & {
    right: $inputIconHorizontalSideIndent + $inputNumberRightIndent;
  }
}

.disabledIconWrap {
  @include disabledIcon;
  right: $inputIconHorizontalSideIndent;
  .inputWrapperWithNumber & {
    right: $inputIconHorizontalSideIndent + $inputNumberRightIndent;
  }
}

.clearIconWrap {
  @include clearIcon;
  right: $inputIconHorizontalSideIndent;

  .rightIconWrap + & {
    right: $clearIconRight;
  }
}

.inputWrapperWithNumber {
  .clearIconWrap {
    right: $inputIconHorizontalSideIndent + $inputNumberRightIndent;
  }
  .rightIconWrap + .clearIconWrap {
    right: $clearIconRight + $inputNumberRightIndent;
  }
}

.passwordInputIcon {
  color: $gray400;

  &:hover {
    color: $gray500;
  }
}

.copyInputIcon {
  color: $gray400;
  cursor: pointer;

  &:hover {
    color: $gray500;
  }
}

:root {
  .ant-input-number-input-wrap{
    height: 100%;
  }
  .ant-input-number-handler-wrap {
    @extend .inputNumberBtns;
  }
}
